<template>
  <div class="trade-buy-sell-input">
    <div class="trade-buy-sell-input__container txt txt--10px txt--grey">
      <!-- <span class="trade-buy-sell-input__label">
        {{ tradeLabel }}
      </span> -->
      <exc-input v-bind="$attrs" v-on="$listeners" />
      <span
        class="trade-buy-sell-input__currency txt--12px txt--weight-500 txt--height-14px txt--color-04 pl-4"
      >
        {{ currency }}
      </span>
    </div>
  </div>
</template>

<script>
import { ExcInput } from '@/components/common'

export default {
  name: 'TradeBuySellInput',
  components: {
    ExcInput,
  },
  props: {
    currency: {
      type: String,
      default: '',
    },
    tradeLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-buy-sell-input {
  &__container {
    position: relative;
  }

  &__currency {
    background: transparent;
    position: absolute;
    bottom: toRem(-15px);
    transform: translateY(-50%);
    right: 10px;
    height: toRem(34px);
    min-width: toRem(36px);
    display: flex;
    align-items: center;
  }

  &__label {
    position: absolute;
    top: calc(50%);
    transform: translateY(-100%);
    left: 14px;
    height: 1.125rem;
    display: flex;
    align-items: center;
  }
}
</style>
